var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArizona(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.246,
    height: 172,
    viewBox: "0 0 146.246 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f0a022}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_arizona",
    transform: "translate(-10.25 -955.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    d: "M15.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2974",
    transform: "translate(0 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    d: "M18.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2975",
    transform: "translate(3.216 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2976",
    d: "M18.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2976",
    transform: "translate(3.216 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    d: "M18.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2977",
    transform: "translate(3.216 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2978",
    d: "M18.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2978",
    transform: "translate(3.216 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    d: "M22.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2979",
    transform: "translate(6.431 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2980",
    d: "M22.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2980",
    transform: "translate(6.431 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2981",
    d: "M22.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2981",
    transform: "translate(6.431 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2982",
    d: "M22.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2982",
    transform: "translate(6.431 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2983",
    d: "M22.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2983",
    transform: "translate(6.431 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    d: "M22.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2984",
    transform: "translate(6.431 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    d: "M22.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2985",
    transform: "translate(6.431 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    d: "M22.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2986",
    transform: "translate(6.431 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2987",
    d: "M22.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2987",
    transform: "translate(6.431 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2988",
    d: "M25.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2988",
    transform: "translate(9.647 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2989",
    d: "M25.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2989",
    transform: "translate(9.647 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2990",
    d: "M25.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2990",
    transform: "translate(9.647 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    d: "M25.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2991",
    transform: "translate(9.647 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2992",
    d: "M25.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2992",
    transform: "translate(9.647 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    d: "M25.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2993",
    transform: "translate(9.647 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2994",
    d: "M25.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2994",
    transform: "translate(9.647 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    d: "M25.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2995",
    transform: "translate(9.647 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    d: "M25.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2996",
    transform: "translate(9.647 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    d: "M25.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2997",
    transform: "translate(9.647 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    d: "M25.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2998",
    transform: "translate(9.647 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    d: "M25.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 2999",
    transform: "translate(9.647 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    d: "M25.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3000",
    transform: "translate(9.647 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    d: "M25.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3001",
    transform: "translate(9.647 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    d: "M25.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3002",
    transform: "translate(9.647 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    d: "M25.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3003",
    transform: "translate(9.647 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    d: "M25.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3004",
    transform: "translate(9.647 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3005",
    d: "M29.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3005",
    transform: "translate(11.718 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3006",
    d: "M29.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3006",
    transform: "translate(11.718 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3007",
    d: "M29.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3007",
    transform: "translate(11.718 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    d: "M29.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3008",
    transform: "translate(11.718 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3009",
    d: "M29.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3009",
    transform: "translate(11.718 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3010",
    d: "M29.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3010",
    transform: "translate(11.718 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    d: "M29.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3011",
    transform: "translate(11.718 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    d: "M29.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3012",
    transform: "translate(11.718 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3013",
    d: "M29.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3013",
    transform: "translate(11.718 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3014",
    d: "M29.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3014",
    transform: "translate(11.718 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3015",
    d: "M29.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3015",
    transform: "translate(11.718 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3016",
    d: "M29.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3016",
    transform: "translate(11.718 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3017",
    d: "M29.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3017",
    transform: "translate(11.718 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3018",
    d: "M29.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3018",
    transform: "translate(11.718 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3019",
    d: "M29.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3019",
    transform: "translate(11.718 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    d: "M29.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3020",
    transform: "translate(11.718 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    d: "M29.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3021",
    transform: "translate(11.718 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    d: "M29.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3022",
    transform: "translate(11.718 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    d: "M32.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3023",
    transform: "translate(14.648 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    d: "M32.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3024",
    transform: "translate(14.648 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    d: "M32.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3025",
    transform: "translate(14.648 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    d: "M32.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3026",
    transform: "translate(14.648 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    d: "M32.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3027",
    transform: "translate(14.648 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    d: "M32.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3028",
    transform: "translate(14.648 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    d: "M32.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3029",
    transform: "translate(14.648 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    d: "M32.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3030",
    transform: "translate(14.648 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    d: "M32.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3031",
    transform: "translate(14.648 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    d: "M32.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3032",
    transform: "translate(14.648 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    d: "M32.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3033",
    transform: "translate(14.648 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    d: "M32.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3034",
    transform: "translate(14.648 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    d: "M32.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3035",
    transform: "translate(14.648 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    d: "M32.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3036",
    transform: "translate(14.648 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    d: "M32.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3037",
    transform: "translate(14.648 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    d: "M32.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3038",
    transform: "translate(14.648 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    d: "M32.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3039",
    transform: "translate(14.648 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    d: "M32.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3040",
    transform: "translate(14.648 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    d: "M36.047 958.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3041",
    transform: "translate(17.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    d: "M36.047 961.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3042",
    transform: "translate(17.577 3.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    d: "M36.047 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3043",
    transform: "translate(17.577 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    d: "M36.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3044",
    transform: "translate(17.577 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    d: "M36.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3045",
    transform: "translate(17.577 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    d: "M36.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3046",
    transform: "translate(17.577 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    d: "M36.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3047",
    transform: "translate(17.577 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    d: "M36.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3048",
    transform: "translate(17.577 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    d: "M36.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3049",
    transform: "translate(17.577 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    d: "M36.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3050",
    transform: "translate(17.577 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    d: "M36.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3051",
    transform: "translate(17.577 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    d: "M36.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3052",
    transform: "translate(17.577 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    d: "M36.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3053",
    transform: "translate(17.577 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    d: "M36.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3054",
    transform: "translate(17.577 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    d: "M36.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3055",
    transform: "translate(17.577 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    d: "M36.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3056",
    transform: "translate(17.577 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    d: "M36.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3057",
    transform: "translate(17.577 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    d: "M36.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3058",
    transform: "translate(17.577 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    d: "M36.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3059",
    transform: "translate(17.577 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    d: "M36.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3060",
    transform: "translate(17.577 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    d: "M36.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3061",
    transform: "translate(17.577 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    d: "M36.047 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3062",
    transform: "translate(17.577 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    d: "M39.547 958.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3063",
    transform: "translate(20.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    d: "M39.547 961.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3064",
    transform: "translate(20.507 3.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    d: "M39.547 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3065",
    transform: "translate(20.507 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    d: "M39.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3066",
    transform: "translate(20.507 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    d: "M39.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3067",
    transform: "translate(20.507 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    d: "M39.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3068",
    transform: "translate(20.507 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    d: "M39.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3069",
    transform: "translate(20.507 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    d: "M39.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3070",
    transform: "translate(20.507 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    d: "M39.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3071",
    transform: "translate(20.507 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    d: "M39.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3072",
    transform: "translate(20.507 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    d: "M39.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3073",
    transform: "translate(20.507 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    d: "M39.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3074",
    transform: "translate(20.507 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    d: "M39.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3075",
    transform: "translate(20.507 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    d: "M39.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3076",
    transform: "translate(20.507 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    d: "M39.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3077",
    transform: "translate(20.507 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    d: "M39.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3078",
    transform: "translate(20.507 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    d: "M39.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3079",
    transform: "translate(20.507 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    d: "M39.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3080",
    transform: "translate(20.507 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    d: "M39.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3081",
    transform: "translate(20.507 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    d: "M39.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3082",
    transform: "translate(20.507 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    d: "M39.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3083",
    transform: "translate(20.507 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    d: "M39.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3084",
    transform: "translate(20.507 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    d: "M39.547 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3085",
    transform: "translate(20.507 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    d: "M43.047 961.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3086",
    transform: "translate(23.436 3.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    d: "M43.047 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3087",
    transform: "translate(23.436 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    d: "M43.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3088",
    transform: "translate(23.436 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    d: "M43.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3089",
    transform: "translate(23.436 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    d: "M43.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3090",
    transform: "translate(23.436 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    d: "M43.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3091",
    transform: "translate(23.436 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    d: "M43.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3092",
    transform: "translate(23.436 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    d: "M43.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3093",
    transform: "translate(23.436 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    d: "M43.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3094",
    transform: "translate(23.436 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    d: "M43.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3095",
    transform: "translate(23.436 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    d: "M43.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3096",
    transform: "translate(23.436 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    d: "M43.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3097",
    transform: "translate(23.436 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    d: "M43.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3098",
    transform: "translate(23.436 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    d: "M43.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3099",
    transform: "translate(23.436 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    d: "M43.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3100",
    transform: "translate(23.436 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    d: "M43.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3101",
    transform: "translate(23.436 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    d: "M43.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3102",
    transform: "translate(23.436 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    d: "M43.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3103",
    transform: "translate(23.436 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    d: "M43.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3104",
    transform: "translate(23.436 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    d: "M43.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3105",
    transform: "translate(23.436 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    d: "M43.047 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3106",
    transform: "translate(23.436 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    d: "M43.047 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3107",
    transform: "translate(23.436 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    d: "M46.547 961.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3108",
    transform: "translate(26.366 3.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    d: "M46.547 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3109",
    transform: "translate(26.366 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    d: "M46.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3110",
    transform: "translate(26.366 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    d: "M46.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3111",
    transform: "translate(26.366 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    d: "M46.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3112",
    transform: "translate(26.366 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    d: "M46.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3113",
    transform: "translate(26.366 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    d: "M46.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3114",
    transform: "translate(26.366 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    d: "M46.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3115",
    transform: "translate(26.366 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    d: "M46.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3116",
    transform: "translate(26.366 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    d: "M46.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3117",
    transform: "translate(26.366 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    d: "M46.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3118",
    transform: "translate(26.366 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    d: "M46.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3119",
    transform: "translate(26.366 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    d: "M46.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3120",
    transform: "translate(26.366 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    d: "M46.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3121",
    transform: "translate(26.366 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    d: "M46.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3122",
    transform: "translate(26.366 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    d: "M46.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3123",
    transform: "translate(26.366 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    d: "M46.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3124",
    transform: "translate(26.366 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    d: "M46.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3125",
    transform: "translate(26.366 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    d: "M46.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3126",
    transform: "translate(26.366 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    d: "M46.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3127",
    transform: "translate(26.366 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    d: "M46.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3128",
    transform: "translate(26.366 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    d: "M46.547 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3129",
    transform: "translate(26.366 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    d: "M46.547 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3130",
    transform: "translate(26.366 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    d: "M50.047 961.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3131",
    transform: "translate(29.295 3.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    d: "M50.047 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3132",
    transform: "translate(29.295 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3133",
    d: "M50.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3133",
    transform: "translate(29.295 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    d: "M50.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3134",
    transform: "translate(29.295 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    d: "M50.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3135",
    transform: "translate(29.295 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    d: "M50.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3136",
    transform: "translate(29.295 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    d: "M50.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3137",
    transform: "translate(29.295 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    d: "M50.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3138",
    transform: "translate(29.295 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    d: "M50.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3139",
    transform: "translate(29.295 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    d: "M50.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3140",
    transform: "translate(29.295 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    d: "M50.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3141",
    transform: "translate(29.295 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    d: "M50.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3142",
    transform: "translate(29.295 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    d: "M50.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3143",
    transform: "translate(29.295 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    d: "M50.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3144",
    transform: "translate(29.295 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    d: "M50.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3145",
    transform: "translate(29.295 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    d: "M50.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3146",
    transform: "translate(29.295 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    d: "M50.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3147",
    transform: "translate(29.295 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    d: "M50.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3148",
    transform: "translate(29.295 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    d: "M50.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3149",
    transform: "translate(29.295 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    d: "M50.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3150",
    transform: "translate(29.295 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    d: "M50.047 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3151",
    transform: "translate(29.295 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    d: "M50.047 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3152",
    transform: "translate(29.295 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    d: "M50.047 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3153",
    transform: "translate(29.295 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    d: "M50.047 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3154",
    transform: "translate(29.295 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    d: "M53.547 961.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3155",
    transform: "translate(32.225 3.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    d: "M53.547 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3156",
    transform: "translate(32.225 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    d: "M53.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3157",
    transform: "translate(32.225 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    d: "M53.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3158",
    transform: "translate(32.225 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    d: "M53.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3159",
    transform: "translate(32.225 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    d: "M53.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3160",
    transform: "translate(32.225 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    d: "M53.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3161",
    transform: "translate(32.225 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    d: "M53.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3162",
    transform: "translate(32.225 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    d: "M53.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3163",
    transform: "translate(32.225 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    d: "M53.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3164",
    transform: "translate(32.225 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    d: "M53.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3165",
    transform: "translate(32.225 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    d: "M53.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3166",
    transform: "translate(32.225 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    d: "M53.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3167",
    transform: "translate(32.225 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    d: "M53.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3168",
    transform: "translate(32.225 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    d: "M53.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3169",
    transform: "translate(32.225 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    d: "M53.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3170",
    transform: "translate(32.225 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    d: "M53.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3171",
    transform: "translate(32.225 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    d: "M53.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3172",
    transform: "translate(32.225 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    d: "M53.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3173",
    transform: "translate(32.225 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    d: "M53.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3174",
    transform: "translate(32.225 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    d: "M53.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3175",
    transform: "translate(32.225 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    d: "M53.547 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3176",
    transform: "translate(32.225 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    d: "M53.547 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3177",
    transform: "translate(32.225 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    d: "M53.547 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3178",
    transform: "translate(32.225 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    d: "M57.047 961.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3179",
    transform: "translate(35.154 3.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    d: "M57.047 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3180",
    transform: "translate(35.154 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    d: "M57.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3181",
    transform: "translate(35.154 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    d: "M57.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3182",
    transform: "translate(35.154 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    d: "M57.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3183",
    transform: "translate(35.154 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    d: "M57.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3184",
    transform: "translate(35.154 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    d: "M57.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3185",
    transform: "translate(35.154 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    d: "M57.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3186",
    transform: "translate(35.154 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    d: "M57.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3187",
    transform: "translate(35.154 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    d: "M57.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3188",
    transform: "translate(35.154 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    d: "M57.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3189",
    transform: "translate(35.154 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    d: "M57.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3190",
    transform: "translate(35.154 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    d: "M57.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3191",
    transform: "translate(35.154 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    d: "M57.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3192",
    transform: "translate(35.154 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    d: "M57.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3193",
    transform: "translate(35.154 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    d: "M57.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3194",
    transform: "translate(35.154 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    d: "M57.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3195",
    transform: "translate(35.154 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    d: "M57.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3196",
    transform: "translate(35.154 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    d: "M57.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3197",
    transform: "translate(35.154 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    d: "M57.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3198",
    transform: "translate(35.154 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    d: "M57.047 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3199",
    transform: "translate(35.154 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    d: "M57.047 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3200",
    transform: "translate(35.154 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    d: "M57.047 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3201",
    transform: "translate(35.154 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    d: "M57.047 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3202",
    transform: "translate(35.154 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    d: "M57.047 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3203",
    transform: "translate(35.154 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    d: "M60.547 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3204",
    transform: "translate(38.084 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    d: "M60.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3205",
    transform: "translate(38.084 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    d: "M60.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3206",
    transform: "translate(38.084 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    d: "M60.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3207",
    transform: "translate(38.084 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    d: "M60.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3208",
    transform: "translate(38.084 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    d: "M60.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3209",
    transform: "translate(38.084 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    d: "M60.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3210",
    transform: "translate(38.084 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    d: "M60.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3211",
    transform: "translate(38.084 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    d: "M60.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3212",
    transform: "translate(38.084 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    d: "M60.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3213",
    transform: "translate(38.084 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    d: "M60.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3214",
    transform: "translate(38.084 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    d: "M60.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3215",
    transform: "translate(38.084 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    d: "M60.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3216",
    transform: "translate(38.084 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    d: "M60.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3217",
    transform: "translate(38.084 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    d: "M60.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3218",
    transform: "translate(38.084 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    d: "M60.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3219",
    transform: "translate(38.084 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    d: "M60.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3220",
    transform: "translate(38.084 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    d: "M60.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3221",
    transform: "translate(38.084 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    d: "M60.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3222",
    transform: "translate(38.084 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    d: "M60.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3223",
    transform: "translate(38.084 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    d: "M60.547 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3224",
    transform: "translate(38.084 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    d: "M60.547 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3225",
    transform: "translate(38.084 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    d: "M60.547 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3226",
    transform: "translate(38.084 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    d: "M60.547 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3227",
    transform: "translate(38.084 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    d: "M64.047 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3228",
    transform: "translate(41.013 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    d: "M64.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3229",
    transform: "translate(41.013 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    d: "M64.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3230",
    transform: "translate(41.013 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    d: "M64.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3231",
    transform: "translate(41.013 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    d: "M64.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3232",
    transform: "translate(41.013 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    d: "M64.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3233",
    transform: "translate(41.013 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    d: "M64.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3234",
    transform: "translate(41.013 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    d: "M64.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3235",
    transform: "translate(41.013 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    d: "M64.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3236",
    transform: "translate(41.013 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    d: "M64.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3237",
    transform: "translate(41.013 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    d: "M64.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3238",
    transform: "translate(41.013 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    d: "M64.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3239",
    transform: "translate(41.013 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    d: "M64.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3240",
    transform: "translate(41.013 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    d: "M64.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3241",
    transform: "translate(41.013 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    d: "M64.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3242",
    transform: "translate(41.013 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    d: "M64.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3243",
    transform: "translate(41.013 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    d: "M64.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3244",
    transform: "translate(41.013 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    d: "M64.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3245",
    transform: "translate(41.013 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    d: "M64.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3246",
    transform: "translate(41.013 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    d: "M64.047 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3247",
    transform: "translate(41.013 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    d: "M64.047 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3248",
    transform: "translate(41.013 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    d: "M64.047 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3249",
    transform: "translate(41.013 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    d: "M64.047 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3250",
    transform: "translate(41.013 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    d: "M64.047 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3251",
    transform: "translate(41.013 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    d: "M67.547 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3252",
    transform: "translate(43.943 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    d: "M67.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3253",
    transform: "translate(43.943 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    d: "M67.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3254",
    transform: "translate(43.943 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    d: "M67.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3255",
    transform: "translate(43.943 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    d: "M67.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3256",
    transform: "translate(43.943 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3257",
    d: "M67.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3257",
    transform: "translate(43.943 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    d: "M67.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3258",
    transform: "translate(43.943 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    d: "M67.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3259",
    transform: "translate(43.943 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    d: "M67.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3260",
    transform: "translate(43.943 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    d: "M67.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3261",
    transform: "translate(43.943 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    d: "M67.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3262",
    transform: "translate(43.943 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    d: "M67.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3263",
    transform: "translate(43.943 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    d: "M67.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3264",
    transform: "translate(43.943 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3265",
    d: "M67.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3265",
    transform: "translate(43.943 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    d: "M67.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3266",
    transform: "translate(43.943 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    d: "M67.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3267",
    transform: "translate(43.943 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3268",
    d: "M67.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3268",
    transform: "translate(43.943 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3269",
    d: "M67.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3269",
    transform: "translate(43.943 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3270",
    d: "M67.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3270",
    transform: "translate(43.943 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3271",
    d: "M67.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3271",
    transform: "translate(43.943 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    d: "M67.547 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3272",
    transform: "translate(43.943 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3273",
    d: "M67.547 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3273",
    transform: "translate(43.943 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3274",
    d: "M67.547 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3274",
    transform: "translate(43.943 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3275",
    d: "M67.547 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3275",
    transform: "translate(43.943 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    d: "M71.047 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3276",
    transform: "translate(46.872 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    d: "M71.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3277",
    transform: "translate(46.872 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    d: "M71.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3278",
    transform: "translate(46.872 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3279",
    d: "M71.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3279",
    transform: "translate(46.872 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3280",
    d: "M71.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3280",
    transform: "translate(46.872 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3281",
    d: "M71.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3281",
    transform: "translate(46.872 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3282",
    d: "M71.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3282",
    transform: "translate(46.872 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    d: "M71.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3283",
    transform: "translate(46.872 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    d: "M71.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3284",
    transform: "translate(46.872 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    d: "M71.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3285",
    transform: "translate(46.872 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    d: "M71.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3286",
    transform: "translate(46.872 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    d: "M71.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3287",
    transform: "translate(46.872 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3288",
    d: "M71.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3288",
    transform: "translate(46.872 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3289",
    d: "M71.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3289",
    transform: "translate(46.872 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    d: "M71.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3290",
    transform: "translate(46.872 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    d: "M71.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3291",
    transform: "translate(46.872 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    d: "M71.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3292",
    transform: "translate(46.872 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    d: "M71.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3293",
    transform: "translate(46.872 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    d: "M71.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3294",
    transform: "translate(46.872 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    d: "M71.047 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3295",
    transform: "translate(46.872 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    d: "M71.047 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3296",
    transform: "translate(46.872 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    d: "M71.047 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3297",
    transform: "translate(46.872 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3298",
    d: "M71.047 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3298",
    transform: "translate(46.872 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    d: "M71.047 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3299",
    transform: "translate(46.872 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    d: "M74.547 965.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3300",
    transform: "translate(49.802 6.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    d: "M74.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3301",
    transform: "translate(49.802 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    d: "M74.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3302",
    transform: "translate(49.802 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    d: "M74.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3303",
    transform: "translate(49.802 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    d: "M74.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3304",
    transform: "translate(49.802 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    d: "M74.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3305",
    transform: "translate(49.802 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    d: "M74.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3306",
    transform: "translate(49.802 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    d: "M74.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3307",
    transform: "translate(49.802 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    d: "M74.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3308",
    transform: "translate(49.802 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    d: "M74.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3309",
    transform: "translate(49.802 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    d: "M74.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3310",
    transform: "translate(49.802 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    d: "M74.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3311",
    transform: "translate(49.802 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    d: "M74.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3312",
    transform: "translate(49.802 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    d: "M74.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3313",
    transform: "translate(49.802 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3314",
    d: "M74.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3314",
    transform: "translate(49.802 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3315",
    d: "M74.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3315",
    transform: "translate(49.802 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3316",
    d: "M74.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3316",
    transform: "translate(49.802 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3317",
    d: "M74.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3317",
    transform: "translate(49.802 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3318",
    d: "M74.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3318",
    transform: "translate(49.802 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3319",
    d: "M74.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3319",
    transform: "translate(49.802 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3320",
    d: "M74.547 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3320",
    transform: "translate(49.802 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3321",
    d: "M74.547 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3321",
    transform: "translate(49.802 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3322",
    d: "M74.547 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3322",
    transform: "translate(49.802 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3323",
    d: "M74.547 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3323",
    transform: "translate(49.802 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3324",
    d: "M78.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3324",
    transform: "translate(52.731 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3325",
    d: "M78.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3325",
    transform: "translate(52.731 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3326",
    d: "M78.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3326",
    transform: "translate(52.731 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3327",
    d: "M78.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3327",
    transform: "translate(52.731 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    d: "M78.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3328",
    transform: "translate(52.731 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    d: "M78.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3329",
    transform: "translate(52.731 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    d: "M78.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3330",
    transform: "translate(52.731 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3331",
    d: "M78.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3331",
    transform: "translate(52.731 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3332",
    d: "M78.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3332",
    transform: "translate(52.731 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3333",
    d: "M78.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3333",
    transform: "translate(52.731 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3334",
    d: "M78.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3334",
    transform: "translate(52.731 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3335",
    d: "M78.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3335",
    transform: "translate(52.731 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    d: "M78.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3336",
    transform: "translate(52.731 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3337",
    d: "M78.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3337",
    transform: "translate(52.731 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3338",
    d: "M78.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3338",
    transform: "translate(52.731 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    d: "M78.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3339",
    transform: "translate(52.731 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    d: "M78.047 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3340",
    transform: "translate(52.731 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    d: "M78.047 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3341",
    transform: "translate(52.731 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    d: "M78.047 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3342",
    transform: "translate(52.731 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    d: "M78.047 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3343",
    transform: "translate(52.731 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3344",
    d: "M78.047 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3344",
    transform: "translate(52.731 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    d: "M78.047 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3345",
    transform: "translate(52.731 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    d: "M78.047 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3346",
    transform: "translate(52.731 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    d: "M78.047 1049.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3347",
    transform: "translate(52.731 76.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3348",
    d: "M81.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3348",
    transform: "translate(54.802 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3349",
    d: "M81.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3349",
    transform: "translate(54.802 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3350",
    d: "M81.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3350",
    transform: "translate(54.802 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    d: "M81.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3351",
    transform: "translate(54.802 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    d: "M81.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3352",
    transform: "translate(54.802 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3353",
    d: "M81.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3353",
    transform: "translate(54.802 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3354",
    d: "M81.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3354",
    transform: "translate(54.802 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    d: "M81.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3355",
    transform: "translate(54.802 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    d: "M81.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3356",
    transform: "translate(54.802 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    d: "M81.547 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3357",
    transform: "translate(54.802 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    d: "M81.547 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3358",
    transform: "translate(54.802 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    d: "M81.547 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3359",
    transform: "translate(54.802 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    d: "M81.547 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3360",
    transform: "translate(54.802 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    d: "M81.547 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3361",
    transform: "translate(54.802 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    d: "M81.547 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3362",
    transform: "translate(54.802 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    d: "M81.547 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3363",
    transform: "translate(54.802 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    d: "M81.547 1024.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3364",
    transform: "translate(54.802 55.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    d: "M81.547 1028.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3365",
    transform: "translate(54.802 58.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    d: "M81.547 1031.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3366",
    transform: "translate(54.802 61.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    d: "M81.547 1035.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3367",
    transform: "translate(54.802 63.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    d: "M81.547 1038.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3368",
    transform: "translate(54.802 66.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    d: "M81.547 1042.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3369",
    transform: "translate(54.802 69.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    d: "M81.547 1045.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3370",
    transform: "translate(54.802 72.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    d: "M81.547 1049.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3371",
    transform: "translate(54.802 76.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    d: "M85.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3372",
    transform: "translate(58.018 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    d: "M85.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3373",
    transform: "translate(58.018 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    d: "M85.047 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3374",
    transform: "translate(58.018 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    d: "M85.047 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3375",
    transform: "translate(58.018 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    d: "M85.047 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3376",
    transform: "translate(58.018 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    d: "M85.047 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3377",
    transform: "translate(58.018 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    d: "M85.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3378",
    transform: "translate(58.018 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    d: "M85.047 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3379",
    transform: "translate(58.018 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    d: "M85.047 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3380",
    transform: "translate(58.018 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    d: "M85.047 1000.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3381",
    transform: "translate(58.018 35.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    d: "M85.047 1003.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3382",
    transform: "translate(58.018 38.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    d: "M85.047 1007.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3383",
    transform: "translate(58.018 41.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    d: "M85.047 1010.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3384",
    transform: "translate(58.018 43.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3385",
    d: "M85.047 1014.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3385",
    transform: "translate(58.018 46.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    d: "M85.047 1017.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3386",
    transform: "translate(58.018 49.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3387",
    d: "M85.047 1021.011a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3387",
    transform: "translate(58.018 52.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3388",
    d: "M88.547 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3388",
    transform: "translate(61.233 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3389",
    d: "M88.547 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3389",
    transform: "translate(61.233 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3390",
    d: "M88.547 975.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3390",
    transform: "translate(61.233 14.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3391",
    d: "M88.547 979.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3391",
    transform: "translate(61.233 17.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3392",
    d: "M88.547 982.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3392",
    transform: "translate(61.233 20.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3393",
    d: "M88.547 986.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3393",
    transform: "translate(61.233 23.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3394",
    d: "M88.547 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3394",
    transform: "translate(61.233 26.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3395",
    d: "M88.547 993.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3395",
    transform: "translate(61.233 29.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3396",
    d: "M88.547 996.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3396",
    transform: "translate(61.233 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3397",
    d: "M92.047 968.511a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3397",
    transform: "translate(64.449 9.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3398",
    d: "M92.047 972.01a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3398",
    transform: "translate(64.449 12.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3399",
    d: "M22.047 989.51a2.4 2.4 0 1 1-2.4-2.4 2.4 2.4 0 0 1 2.4 2.4z",
    className: "cls-1",
    "data-name": "Path 3399",
    transform: "translate(6.431 26.378)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArizona);
export default __webpack_public_path__ + "static/media/icon-arizona.5a62ad4dc67bcc81513e78ae808c7973.svg";
export { ForwardRef as ReactComponent };